import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "has-text-centered"
}
const _hoisted_3 = { class: "is-size-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.activeComponent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_b_breadcrumb, {
            size: "is-large",
            separator: "has-succeeds-separator",
            "aria-label": "breadcrumbs"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_breadcrumb_item, {
                tag: "a",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToList()), ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('integrations.title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_b_breadcrumb_item, {
                tag: "a",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.goToGallery()), ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('integrations.galleryTitle')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_b_breadcrumb_item, { active: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.templateLabel), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeComponent), { onSaved: _ctx.goToList }, null, 40, ["onSaved"]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('integrations.notFound')), 1),
          _createVNode(_component_b_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToGallery())),
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.back')), 1)
            ]),
            _: 1
          })
        ]))
  ]))
}